import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  descriptionContainer: {
    scrollMarginTop: "100px",
    marginBottom: 84,
  },
  descriptionSectionTitle: {
    marginBottom: 30,
    fontSize: 36,
    lineHeight: "1.22",
    fontWeight: 500,
  },
  descriptionTitle: {
    lineHeight: "26px",
    fontSize: 20,
    marginBottom: 24,
  },
  leftDescription: {
    width: "30%",
    lineHeight: "25px",
    color: theme.palette.text.primary,
    overflowWrap: "anywhere",
    paddingRight: 50,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 20,
    },
  },
  rightDescription: {
    width: "70%",
    marginBottom: "25px",
    lineHeight: "25px",
    color: theme.palette.text.secondary,
    overflowWrap: "anywhere",
  },
  descriptionParagraph: {
    marginTop: 15,
    marginBottom: 24,
    whiteSpace: "pre-line",
    "&:first-child": {
      marginTop: 0,
    },
  },
  button: {
    "&": {
      border: 0,
      padding: "5px 0",
    },
    "&:hover": {
      backgroundColor: "transparent",
      border: 0,
    },
  },
}));
